<template>
  <div class="login-page">
    <div class="login-wrapper">
      <div class="login-form-wrapper">
        <div class="logo">
          <img src="../../assets/images/login-logo.png" /> <span>爱明玥</span>
        </div>
        <div class="login-form">
          <el-form
            v-if="loginType === 'account'"
            class="form"
            :model="loginForm"
            ref="loginForm"
            :rules="loginFormjRules"
            label-position="top"
          >
            <el-form-item prop="account" label="账号：">
              <el-input
                v-model="loginForm.account"
                placeholder="请输入您的账号"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password" label="密码：">
              <el-input
                type="password"
                v-model="loginForm.password"
                placeholder="请输入您的密码"
                @keyup.enter.native="confirmBrowserType"
              ></el-input>
            </el-form-item>
            <el-form-item class="marB0 pwd">
              <el-checkbox class="login-checkbox" v-model="loginForm.remember"
                >记住密码</el-checkbox
              >
              <span class="forget" @click="forgetPwd">重置密码</span>
            </el-form-item>
            <el-form-item>
              <el-button
                class="login-btn"
                round
                type="primary"
                :loading="loginLoading"
                @click="confirmBrowserType"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
          <div v-else class="wechatForm">
            <div class="qrcode" v-show="codeObj.qrStatus === 'success'">
              <img :src="codeObj.qrCodeUrl" alt="二维码" />
              <div>微信扫描二维码登录</div>
            </div>
            <div class="qrcode" v-show="codeObj.qrStatus === 'error'">
              <i class="el-icon-error"></i>
              <div style="text-align: center">
                <p>二维码加载失败</p>
                <p>请刷新二维码后重新扫描</p>
                <el-button
                  type="primary"
                  round
                  size="mini"
                  @click="_generateQrcode"
                  >刷新二维码</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="feature" v-if="!isFromEyeJiaJia">
          <el-button
            class="login-downLoad"
            size="small"
            round
            @click="registerDialog = true"
            >新用户注册</el-button
          >
          <el-button
            class="login-downLoad"
            size="small"
            round
            @click="softwareDownloadDialog = true"
            >软件下载</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      title="欢迎加入爱明玥"
      :visible.sync="registerDialog"
      center
      width="30%"
      class="register-dialog"
    >
      <div class="register-wrapper">
        <p>1、扫码添加训练指导微信</p>
        <div>
          <img
            class="we-public"
            src="../../assets/images/amy-wepublic.png"
            alt="公众号"
          />
        </div>
        <p>2、发送相关检查报告开通账号</p>
        <el-button
          class="register-btn"
          round
          type="primary"
          @click="registerDialog = false"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="重置密码"
      :visible.sync="forgetPwdDialog"
      class="forgetDialog"
      center
      width="36%"
      v-if="forgetPwdDialog"
    >
      <el-form
        :model="forgetForm"
        :rules="loginFormjRules"
        ref="forgetForm"
        class="forgetForm"
        label-position="top"
      >
        <el-form-item label="账号：" prop="account">
          <el-input
            v-model="forgetForm.account"
            placeholder="请输入账号"
          ></el-input>
          <img class="forgetImg" src="../../assets/images/account.png" />
        </el-form-item>
        <el-form-item label="手机号：" prop="mobile">
          <el-input
            v-model="forgetForm.mobile"
            placeholder="请输入手机号"
          ></el-input>
          <img class="forgetImg" src="../../assets/images/phone.png" />
        </el-form-item>
        <el-form-item label="图片验证码：" required>
          <el-col :span="18">
            <el-form-item>
              <el-input
                v-model="picCode"
                placeholder="请输入图片验证码"
                @blur="picStatus ? no() : handlePicCode()"
              ></el-input>
              <img class="forgetImg" src="../../assets/images/pic.png" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div class="picCode" @click="getPicCode"><img :src="picUrl" /></div>
          </el-col>
        </el-form-item>
        <el-form-item label="短信验证码：" required>
          <el-col :span="18">
            <el-form-item prop="random">
              <el-input
                v-model="forgetForm.random"
                placeholder="请输入短信验证码"
              ></el-input>
              <img class="forgetImg" src="../../assets/images/sms.png" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div class="smsCode" @click="sendSmsCode">获取验证码</div>
          </el-col>
        </el-form-item>
      </el-form>
      <div>
        <el-button class="reset-btn" round type="primary" @click="resetPassword"
          >重置密码</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="loginPromptDialog"
      class="prompt"
      center
      width="30%"
    >
      <div class="message">{{ message }}</div>
      <div class="prompt-btn">
        <el-button
          v-if="version === 'mac'"
          class="probt"
          round
          @click="downloadFile('Chrome')"
          type="primary"
          >下载谷歌浏览器</el-button
        >
        <el-button
          v-if="version === 'win'"
          class="probt"
          round
          @click="downloadFile('Chrome')"
          type="primary"
          >下载谷歌浏览器</el-button
        >
        <el-button @click="continueSubmit" class="probt" round type="primary"
          >继续登录</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="下载"
      :visible.sync="softwareDownloadDialog"
      class="download"
      center
      :width="downloadDialogWidth"
    >
      <div class="win downCommon" v-for="item in downloadList" :key="item.id">
        <img :src="item.imgUrl" />
        <p class="name">{{ item.title }}</p>
        <p class="win-use">{{ item.remark }}</p>
        <div class="btn">
          <el-button
            class="softDownload"
            type="primary"
            round
            @click="handleDownload(item)"
            >立即下载</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible="showTrainerWechat" width="600px" :show-close="false">
      <TrainerWechatDialog
        :qrcode="twQrcode"
        :phone="phone"
        @confirm="handleConfirm"
      ></TrainerWechatDialog>
    </el-dialog>
    <div class="be-footer" @click="clickRecordNo">冀ICP备2022006169号</div>
  </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'
import loginFormjRules from '@utils/rules/loginFormRules'
import { validateForm, detectOS, IEVersion, checkImgLoaded } from '@utils'
import {
  smsCode,
  picCodeNew,
  resetPassword,
  generateQrcode,
  loop,
  getContent,
} from '@api/login'
import {
  getAccount,
  getPassword,
  removePassword,
  removeAccount,
  setToken,
  getRole,
} from '@utils/auth'
import * as Code from '@src/constant/request'
import bUtils from 'babyeye-utils'
import { namespace } from 'vuex-class'
import TrainerWechatDialog from '@/components/TrainerWechatDialog.vue'
import { AccountType, CONTENT_TYPE, PAGE_TYPE } from '@/constant/user'

const moduleUser = namespace('user')

@Component({
  components: { TrainerWechatDialog },
})
export default class Login extends Vue {
  loginType = 'account'
  codeObj = {
    qrCodeUrl: '',
    qrStatus: 'success',
  }
  timeObj = {
    startTime: 0,
    endTime: 0,
    timer: 0,
  }
  loginForm = {
    account: '',
    password: '',
    remember: false,
  }
  loginLoading = false
  loginPromptDialog = false
  softwareDownloadDialog = false
  message = ''

  forgetPwdDialog = false
  forgetForm = {}
  picUrl = ''
  picCode = ''
  picStatus = false
  downloadList = []

  registerDialog = false

  get isFromEyeJiaJia() {
    return Boolean(this.$route.query.from) || getRole() === AccountType.MYOPIA
  }

  @moduleUser.Action Login
  @moduleUser.Mutation SET_TOKEN
  @moduleUser.Mutation SET_WID

  @moduleUser.State
  twQrcode
  @moduleUser.State
  phone

  @moduleUser.State
  showTrainerWechat

  @moduleUser.Mutation
  SET_SHOW_TRAINER_WECHAT

  created() {
    this.loginFormjRules = loginFormjRules
    this._getContent({ contentType: CONTENT_TYPE.DOWNLOAD }).then(res => {
      if (res && res.length > 0) {
        this.downloadList = res.filter(
          item => item.weight < 30 && item.weight > 19
        )
      }
    })
  }

  mounted() {
    this.loadLoginForm()
  }
  get downloadDialogWidth() {
    const len = this.downloadList.length || 1
    return 300 * len + 'px'
  }
  get inElectron() {
    return navigator.userAgent.toLowerCase().indexOf('electron') > -1
  }
  loadLoginForm() {
    const paramsObj = bUtils.getUrlParams(location.href)
    if (paramsObj) {
      this.loginForm = {
        account: paramsObj.account,
        password: paramsObj.pd,
        remember: false,
      }
      removePassword()
      removeAccount()
    } else {
      if (getAccount() && getPassword()) {
        this.loginForm = {
          account: getAccount(),
          password: getPassword(),
          remember: true,
        }
      } else {
        this.loginForm = {
          account: '',
          password: '',
          remember: false,
        }
      }
    }
  }

  async _generateQrcode() {
    this.codeObj.qrStatus = 'success'
    try {
      const {
        data: { qrCodeUrl, sceneId },
      } = await generateQrcode()
      const isLoaded = await checkImgLoaded(qrCodeUrl)
      this.codeObj.qrCodeUrl = qrCodeUrl
      if (isLoaded) {
        this.codeObj.qrStatus = 'success'
        this.timeObj.startTime = Date.now()
        this.timeObj.timer = setInterval(this._loop, 2000, sceneId)
      } else {
        this.codeObj.qrStatus = 'error'
        clearInterval(this.timeObj.timer)
      }
    } catch (error) {
      console.log(error)
      this.codeObj.qrStatus = 'error'
      clearInterval(this.timeObj.timer)
    }
  }

  // 计算二维码是否过期
  timing() {
    this.timeObj.endTime = Date.now()
    if (this.timeObj.endTime - this.timeObj.startTime > 120 * 1000) {
      console.log('过期')
      clearInterval(this.timeObj.timer)
      this._generateQrcode()
    }
  }
  // 轮询
  async _loop(scene_id) {
    this.timing()
    try {
      const { code, data } = await loop(scene_id)
      if (code === Code.SUCCESS) {
        clearInterval(this.timeObj.timer)
        console.log(data, 'ddd')
        setToken(data.token)
        this.SET_TOKEN(data.token)
        if (data.role === '2') {
          this.$router.push({ path: '/home' })
        } else {
          this.$router.push({ path: '/familyTrain' })
        }
      }
      if (code === Code.WECHAT_UNBIND_ERROR) {
        clearInterval(this.timeObj.timer)
        this.SET_WID(data)
        this.$router.push({ path: '/bindAccount' })
      }
    } catch (error) {
      console.log(error)
    }
  }

  handleTabClick({ name }) {
    name === 'wechat'
      ? this._generateQrcode()
      : clearInterval(this.timeObj.timer)
  }

  openDoctor() {
    window.open('http://sgeye.com/#/login')
  }

  async forgetPwd() {
    this.forgetPwdDialog = true
    this.forgetForm = {
      account: '',
      mobile: '',
      random: '',
    }
    this.picCode = ''
    this.picStatus = false
    this.getPicCode()
  }
  async getPicCode() {
    const res = await picCodeNew()
    // this.picUrl = process.env.VUE_APP_IMAGECODE + res.data
    this.picUrl = URL.createObjectURL(res)
    // picCodeNew().then(res => {
    //   this.picUrl = 'data:image/png;base64,' + btoa(new Uint8Array(res).reduce((data, byte) => data + String.fromCharCode(byte), ''))
    // })
  }
  no() {}
  async handlePicCode() {
    if (this.picCode === '') {
      this.$messhandlePicCodeage.warning('请输入图片验证码')
    }
    // else {
    //   const res = await confirmPicCode(this.picCode.trim())
    //   this.picStatus = res.code !== 0 ? false : true
    // }
  }
  async sendSmsCode() {
    if (this.forgetForm.account && this.forgetForm.mobile && this.picCode) {
      const res = await smsCode({
        mobile: this.forgetForm.mobile,
        account: this.forgetForm.account,
        imageCode: this.picCode,
      })
      res.code !== 0
        ? this.$message.warning(res.message)
        : this.$message.success(res.message)
    } else {
      this.$message.warning('账号、手机号、图片验证码不能为空')
    }
  }

  async resetPassword() {
    // if (!this.picStatus) {
    //   this.handlePicCode()
    // } else {
    const valid = await validateForm.call(this, 'forgetForm')
    if (valid) {
      const data = {
        mobile: this.forgetForm.mobile,
        account: this.forgetForm.account,
        smsCode: this.forgetForm.random,
      }
      const res = await resetPassword(data)
      if (res.code === 0) {
        this.forgetPwdDialog = false
        this.loginForm.account = this.forgetForm.account
        this.loginForm.password = ''
      }
      res.code !== 0
        ? this.$message.warning(res.message)
        : this.$message.success(res.message)
    }
    // }
  }

  handleDownload(item) {
    if (item.link) {
      if (item.link.endsWith('.apk') || item.link.endsWith('.exe')) {
        window.location.href = item.link
      } else {
        window.open(item.link)
      }
    }
  }

  downloadFile(data) {
    const downloadUrl = 'https://sdx-1253527671.cos.ap-beijing.myqcloud.com/'
    switch (data) {
      case 'Chrome':
        // 跳转新页面
        window.open(`https://www.google.cn/intl/zh-CN/chrome/`)
        break
      case 'Shiduoxing':
        // electron下跳转新页面会遮挡，所以直接更改本页面地址
        location.href = downloadUrl + 'shiduoxing-win-2.1.0.exe'
        break
      case 'sdx-rs':
        location.href = downloadUrl + 'ruoshi-v1.3.6.apk'
        break
      case 'sdx-tj':
        location.href = downloadUrl + 'sdxtj-v1.2.7.apk'
        break
      default:
        break
    }
  }
  get version() {
    return detectOS()
  }
  confirmBrowserType() {
    let UA = navigator.userAgent
    if (IEVersion()) {
      this.loginPromptDialog = true
      this.message = '网页对IE浏览器不做技术支持'
    } else if (UA.indexOf('Chrome') < 0 && UA.indexOf('360') < 0) {
      this.loginPromptDialog = true
      this.message = '为了您的使用体验，建议使用谷歌浏览器或者360浏览器登录'
    } else {
      this.handleSubmit()
    }
  }
  continueSubmit() {
    this.loginPromptDialog = false
    this.handleSubmit()
  }
  async handleSubmit() {
    const valid = await validateForm.call(this, 'loginForm')
    valid && this.login()
  }
  async login() {
    try {
      this.loginLoading = true
      await this.Login(this.loginForm)
      this.$router.push({ path: '/' })
    } catch (error) {
      console.log(error)
      this.$router.push({ path: '/login' })
    } finally {
      this.loginLoading = false
    }
  }

  handleConfirm() {
    this.SET_SHOW_TRAINER_WECHAT(false)
  }
  async _getContent({ contentType, account }) {
    const { data } = await getContent({
      content_type: contentType,
      plat_form: 1, // amyok
      page: PAGE_TYPE.LOGIN,
      account: account,
    })
    return data
  }
  clickRecordNo() {
    const href = 'https://beian.miit.gov.cn/'
    window.open(href)
  }
}
</script>
<style lang="scss">
.register-dialog {
  .el-dialog__title {
    color: #595ed3;
  }
}
</style>
<style lang="scss" scoped>
@import '@styles/variable.scss';
.register-wrapper {
  padding: 0 30px;
  .we-public {
    width: 180px;
    height: 180px;
  }
  p {
    font-size: 16px;
    margin: 0;
    line-height: 24px;
  }
  div {
    text-align: center;
    margin-bottom: 10px;
  }
  .register-btn {
    margin-top: 20px;
  }
}
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-image: url('../../assets/images/login-bg.png');
  .login-wrapper {
    display: flex;
    width: 632px;
    height: 600px;
    border-radius: 10px;
    .login-form-wrapper {
      border-radius: 10px;
      background-color: #fff;
      width: 632px;
      .logo {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 40px;
        text-align: center;
        margin-bottom: 30px;
        img {
          width: 90px;
          height: 60px;
          margin-bottom: 30px;
        }
        span {
          display: block;
          font-size: 30px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          letter-spacing: 10px;
        }
        div {
          font-size: 40px;
          color: #007afd;
        }
      }
      .login-form {
        padding: 0px 120px 0px 100px;
        width: 632px;
        .wechatForm {
          height: 270px;
          font-size: 14px;
          .qrcode {
            height: 252px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            img {
              height: 200px;
              width: 200px;
              margin-bottom: 10px;
            }
            i {
              color: #f56c6c;
              font-size: 100px;
            }
          }
        }
        .login-btn {
          width: 100%;
          border-radius: 5px !important;
          background: $color-text-bg;
          border-color: $color-text-bg;
        }
      }
      .feature {
        width: 632px;
        padding: 0px 120px 0px 100px;
        display: flex;
        justify-content: space-between;
        .login-downLoad {
          width: 45%;
          height: 40px;
          border-radius: 5px !important;
          // background: $color-text-bg;
          color: $color-text-bg;
          border-color: $color-text-bg;
        }
      }
    }
  }
}
.smsCode,
.picCode {
  margin-left: 15px;
  text-align: center;
  color: $color-text-bg;
  height: 40px;
  cursor: pointer;
  img {
    height: 40px;
    width: 100%;
  }
}
.forgetImg {
  position: absolute;
  top: 10px;
  left: 10px;
}
.reset-btn,
.register-btn {
  width: 100%;
  background: $color-text-bg;
  border-color: $color-text-bg;
}
.pwd {
  position: relative;
  .forget {
    position: absolute;
    right: 0;
    color: $color-text-bg;
    cursor: pointer;
  }
}
.softDownload {
  min-width: 140px;
  border-color: #fc6393;
  background-color: #fc6393;
}
.message {
  margin-bottom: 30px;
  font-size: 18px;
  color: $color-text-bg;
}
.probt {
  min-width: 140px;
  border-color: $color-text-bg;
  background-color: $color-text-bg;
}
.downCommon {
  color: $color-text-bg;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 240px;
  height: 260px;
  border: 1px solid $color-text-bg;
  border-radius: 15px;
  padding: 15px 10px;
  img {
    width: 66px;
    height: 66px;
    max-width: 66px;
    max-height: 66px;
  }
  .name {
    font-size: 16px;
    font-weight: 600;
  }
  .btn {
    display: none;
  }
  &.win {
    &:hover {
      border: none;
      box-shadow: 0 0 12px rgba(89, 94, 211, 0.4);
      .win-use {
        display: none;
      }
      .btn {
        display: block;
      }
    }
  }
  &.mac {
    &:hover {
      border: none;
      box-shadow: 0 0 12px rgba(89, 94, 211, 0.4);
      .mac-use {
        display: none;
      }
      .btn {
        display: block;
      }
    }
  }
}
.el-form--label-top .el-form-item__label {
  padding-bottom: 10px;
}
.be-footer {
  cursor: pointer;
  position: fixed;
  bottom: 10px;
  color: #fff;
  margin: 0 auto;
}
</style>
